<template>
  <div class="app-auth-shell">
    <div class="app-auth-shell__blob--primary" aria-hidden="true" />
    <div class="app-auth-shell__blob--secondary" aria-hidden="true" />

    <header class="app-auth-shell__header">
      <RouterLink to="/" class="-m-1.5 p-1.5 transition-opacity hover:opacity-80">
        <span class="sr-only">Givaroo</span>
        <img
          class="h-12 w-auto sm:h-14"
          src="../../assets/givvy.png"
          alt="Givaroo kangaroo logomark"
        />
      </RouterLink>
      <RouterLink v-if="backTo" :to="backTo" class="auth-shell-link">
        {{ backLabel }}
      </RouterLink>
    </header>

    <main class="app-auth-shell__main">
      <div class="app-auth-shell__card app-auth-shell__card--split">
        <div class="grid min-h-[28rem] grid-cols-1 md:grid-cols-2">
          <aside class="app-auth-shell__aside">
            <img :src="logoWide" alt="Givaroo" class="h-28 w-auto object-contain lg:h-32" />
            <p class="mt-6 max-w-xs text-center text-sm leading-relaxed text-gray-600">
              Secure access for canvassing teams, campaign managers, and nonprofit partners.
            </p>
          </aside>

          <div class="app-auth-shell__form-panel">
            <img
              :src="logoWide"
              alt="Givaroo"
              class="mx-auto mb-8 h-16 w-auto object-contain md:hidden"
            />
            <slot />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import logoWide from '@/assets/logo-blue-wide-small.png'

defineProps({
  backTo: {
    type: [String, Object],
    default: null,
  },
  backLabel: {
    type: String,
    default: 'Back to home',
  },
})
</script>
